import { createContext, useContext, useState } from 'react';

// CONTEXT PRIVATE -----------------------------------------------------------------------------------------------

/** @type {React.Context<null | {data: Map<string, string>, appendData: function(Record<string, string>): void}>} */
const SearchParamsContext = createContext(null);

/** @return {{data: Map<string, string>, appendData: function(Record<string, string>): void}} */
const useInitSearchParamsContext = () => {
  const [data, setData] = useState(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return new Map(searchParams.entries());
  });
  return {
    data: data,
    appendData: (newData) => {
      if (newData != null && typeof newData == 'object' && !Array.isArray(newData)) {
        const entities = Object.entries(newData)
            .filter(([key, value]) => typeof key == 'string' && typeof value == 'string');
        if (entities.length > 0) {
          setData(new Map([...data.entries(), ...entities]));
        }
      }
    },
  };
};

// CONTEXT PUBLIC -------------------------------------------------------------------------------------------------

/** @return {{data: Map<string, string>, appendData: function(Record<string, string>): void}} */
export const useSearchParamsContext = () => {
  const ctx = useContext(SearchParamsContext);
  if (ctx == null) {
    throw new Error('Search params context not init!');
  }
  return ctx;
};

export const SearchParamsProvider = ({ children }) => {
  const value = useInitSearchParamsContext();
  return <SearchParamsContext.Provider value={value}>{children}</SearchParamsContext.Provider>;
};
